import React from 'react';
import { createUseStyles } from 'react-jss';
import { PathMissingIcon } from '@patternfly/react-icons';
const useStyles = createUseStyles({
    notFoundIcon: { height: '150px', width: '150px' },
});
export const NotFoundIcon = (props) => (React.createElement(PathMissingIcon, Object.assign({}, props, { className: useStyles().notFoundIcon })));
export default NotFoundIcon;
